export default "__VITE_ASSET__1941d2ca__"